import { SectionCard } from '../SectionCard';
import Stack from '../Stack';
import UpgradeToSpateProLink from './UpgradeToSpateProLink';
import featureListStyleImage from '@/assets/icons/base/feature-list-style-image.svg';
import styled from 'styled-components';

const MessageWrapper = styled(Stack)`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: ${({ theme }) => theme.fontSize_base};
    text-wrap: balance;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const MessageHeading = styled.h2`
    margin-top: 0;
    padding: 0;
    font-family: inherit;
    font-weight: 700;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.gray_900};
    text-transform: capitalize;
`;

const MessageParagraph = styled.p`
    margin-top: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.style_primary};
    font-weight: 500;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.gray_900};
    line-height: normal;
`;

const FeatureListItem = styled.li`
    font-family: ${({ theme }) => theme.style_primary};
    font-weight: 500;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.gray_900};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
`;

function NoAccessMessageTikTok(props) {
    return (
        <SectionCard css="padding: 2rem 1rem;">
            <MessageWrapper $space="1.5rem">
                <Stack
                    $space="1rem"
                    css="display: flex; flex-direction: column; align-items: center;"
                >
                    <MessageHeading>Don’t Miss Out</MessageHeading>
                    <MessageParagraph>
                        TikTok data is only a click away.
                    </MessageParagraph>
                </Stack>
                <Stack
                    as="ul"
                    $space=".75rem"
                    $listStyleImage={featureListStyleImage}
                    css={`
                        font-size: 0.875rem;
                        font-weight: 500;
                        color: ${({ theme }) => theme.gray_900};
                        margin-top: 0;
                        list-style: none;
                        padding-inline-start: 0;

                        & li::before {
                            content: '';
                            display: inline-block;
                            width: 1.4rem;
                            height: 1.4rem;
                            background: url('${({ $listStyleImage }) =>
                                    $listStyleImage}')
                                no-repeat 0 0;
                        }
                    `}
                >
                    <FeatureListItem>
                        Explore the hashtags and brands trending across TikTok
                    </FeatureListItem>
                    <FeatureListItem>View top posts</FeatureListItem>
                    <FeatureListItem>
                        Track your brand’s performance
                    </FeatureListItem>
                </Stack>
                <Stack css="display: flex; justify-content: center;">
                    <UpgradeToSpateProLink />
                </Stack>
            </MessageWrapper>
        </SectionCard>
    );
}

export default NoAccessMessageTikTok;
